export default "__VITE_ASSET__bhYSPUrb__"